export default __webpack_public_path__ + "static/media/cart.f3b9778a.gif";